import './outage.scss';

import shuffle from 'lodash/shuffle';
import { string } from 'prop-types';
import React from 'react';
import Countdown from 'react-countdown';

import Header from '../../layout/Header';
import CountdownRenderer from '../CountdownRenderer';

class OutageScreenSaver extends React.Component {
  state = {
    images: [
      'KK.gif',
      'Raphael.gif',
      'Lena.gif',
      'Varya.gif',
      'Andrey.gif',
      'Kerem.gif',
      'Martin.gif',
      'Sebastian.gif',
      'David.gif',
      'KC.gif',
    ],
  };

  componentDidMount() {
    this.setState(state => ({ images: shuffle(state.images) }));
  }

  renderImageRow = images => {
    return (
      <div className="d-flex">
        {images.map((image, index) => {
          const imgPath = `/images/maintenance-gifs/${image}`;
          return (
            <a
              key={index} // eslint-disable-line react/no-array-index-key
              rel="noreferrer"
              href={imgPath}
              target="_blank"
            >
              <img
                src={imgPath}
                key={image}
                alt={image.split('.')[0]}
                className="c-outageScreenSaver__image"
              />
            </a>
          );
        })}
      </div>
    );
  };

  render() {
    const { end } = this.props;
    const { images } = this.state;
    const firstSet = images.slice(0, images.length / 2);
    const secondSet = images.slice(images.length / 2);
    return (
      <div className="c-outageScreenSaver bg-white">
        <Header showNavigation={false} />
        <p className="text-center c-outageScreenSaver__content">
          {this.renderImageRow(firstSet)}
          <br />
          Sorry!
          <br />
          Sales Cockpit is currently not accessible.
          <br />
          We are working on making it even better!
          <br />
          The application should be back up in
          <br />
          {end ? (
            <div className="c-outageScreenSaver__countdown mt-1">
              <Countdown date={end} renderer={CountdownRenderer} />
            </div>
          ) : (
            'a few minutes.'
          )}
          <br />
          <br />
          {this.renderImageRow(secondSet)}
        </p>
      </div>
    );
  }
}

OutageScreenSaver.propTypes = { end: string };
OutageScreenSaver.defaultProps = { end: undefined };

export default OutageScreenSaver;
